import React from 'react';

interface FormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  errors?: Record<string, string>;
}

interface CheckoutContactFormProps {
  formData: FormData;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export function CheckoutContactForm({ formData, handleInputChange }: CheckoutContactFormProps) {
  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold">Et saaksime sinuga ühendust võtta</h2>
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Eesnimi</label>
          <input
            type="text"
            name="firstName"
            value={formData.firstName}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent ${
              formData.errors?.firstName ? 'border-red-500' : ''
            }`}
          />
          {formData.errors?.firstName && (
            <p className="text-red-500 text-sm mt-1">{formData.errors.firstName}</p>
          )}
        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Perenimi</label>
          <input
            type="text"
            name="lastName"
            value={formData.lastName}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent ${
              formData.errors?.lastName ? 'border-red-500' : ''
            }`}
          />
          {formData.errors?.lastName && (
            <p className="text-red-500 text-sm mt-1">{formData.errors.lastName}</p>
          )}
        </div>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">E-post</label>
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleInputChange}
          className={`w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent ${
            formData.errors?.email ? 'border-red-500' : ''
          }`}
        />
        {formData.errors?.email && (
          <p className="text-red-500 text-sm mt-1">{formData.errors.email}</p>
        )}
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">Telefon</label>
        <input
          type="tel"
          name="phone"
          value={formData.phone}
          onChange={handleInputChange}
          className={`w-full px-4 py-3 rounded-lg border focus:ring-2 focus:ring-[#4FC1E9] focus:border-transparent ${
            formData.errors?.phone ? 'border-red-500' : ''
          }`}
        />
        {formData.errors?.phone && (
          <p className="text-red-500 text-sm mt-1">{formData.errors.phone}</p>
        )}
      </div>
    </div>
  );
}